import React, { useState } from 'react';
import PrimaryButtonComponent from '../Components/Buttons/PrimaryButton/PrimaryButton.component';
import { httpSignupNewsletter } from '../Hooks/newsletter/newsletter.post.hooks';
import { NewsletterContainer, NewsletterForm } from './Newsletters.styles';

const NewsletterSignup = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await httpSignupNewsletter(email);
      const data = await res.json();
      if (res.ok) {
        setStatus(data.msg || 'You have been signed up for our newsletter!');
      } else {
        setStatus(data.msg || 'Failed to sign up for the newsletter');
      }
    } catch (err) {
      setStatus('An error occured. Please try again');
    }
  };
  return (
    <NewsletterContainer>
      <p>Sign up for monthly emails about industry updates</p>
      <NewsletterForm>
        <input
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Yoda@safety.com"
        />
        <PrimaryButtonComponent span="Subscribe" functionName={handleSubmit} />
      </NewsletterForm>
      <p>{status}</p>
      <span>Unsubscribe at any time</span>
    </NewsletterContainer>
  );
};

export default NewsletterSignup;
